<template>
  <el-table-column
    prop="from"
    sortable="custom"
    label="Helyettesítés kezdete"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.from">{{ scope.row.from | date }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'from',
  };
</script>
